// @flow

import ajax from 'services/ajax/ajax';
import url from '@active/awe-ui-core/lib/services/url';

export const getRoutes = (
  param: { applicationName: string },
  mapSuccess: Function,
) => ajax.get(
  url(`/results/events/${param.applicationName}/routes`).value(),
  { mapSuccess });

export const getHistory = (
  param: { applicationName: string },
  mapSuccess: Function,
) => ajax.get(
  url(`/results/events/${param.applicationName}/result/import/histories`).value(),
  { mapSuccess });

export const getRouteResultFileId = (
  param: {
    applicationName: string,
    routeId: number,
    sportsType: string,
    distanceName: string,
  },
  mapSuccess: Function,
  mapFailure: Function,
) => ajax.get({
  url: url(`/results/events/${param.applicationName}/result/export`)
    .appendParam('routeId', param.routeId)
    .appendParam('sportsType', param.sportsType)
    .appendParam('distanceName', param.distanceName)
    .value(),
}, { mapSuccess, mapFailure });

export const checkGenerateRouteResultFileStatus = (
  param: {
    applicationName: string,
    uuid: string
  },
  mapSuccess: Function,
  mapFailure: Function,
) => ajax.get({
  url: url(`/results/events/${param.applicationName}/result/file/${param.uuid}/status`).value(),
}, { mapSuccess, mapFailure });
